import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() => ({
  root: {
    width: 360,
    height: 56,
    borderRadius: 8,
    padding: '8px 0 8px 16px',
    border: '1px solid #030C21',
    fontSize: 16,
    color: variables.richBlack,

    '@media (max-width: 600px)': {
      width: 270,
      fontSize: 13,
    },
  },
  hideSearch: {
    display: 'none',
  },
  icon: {
    color: variables.richBlack,
  },
}));
